import React from 'react';
// Components
import SetupAma from 'components/common/SetupAma/SetupAma';

const SetupOrganizationAma: React.FC = () => {
  return <SetupAma />;
};

export default SetupOrganizationAma;
